import { render } from "./MyModal.vue?vue&type=template&id=df5e3bd6&scoped=true"
const script = {}

import "./MyModal.vue?vue&type=style&index=0&id=df5e3bd6&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5e3bd6"]])

export default __exports__